import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { clearOsOdCache, dealerWiseOsOdReport, downloadInvoiceAgeingPdf, downloadOsOdExcel } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import Enabled from '@/components/Enabled/index.vue';
import { getBranches } from '@/api/locations/branches';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isSuperAdmin, isZonalManager } from '@/common';
import { getAgentById } from '@/api/agents';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = '';
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.agentList = [];
    this.dealerList = [];
    this.stateList = [];
    this.cityList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.grandTotal = null; // rename grandTotal → grandTotal or keep and assign
    this.assignedBranches = [] || null;
    this.showFilters = false;
    this.agentUserList = [];
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.statusOptions = [{
      label: 'Locked',
      key: 'Blocked'
    }, {
      label: 'Unlocked',
      key: 'Approved'
    }];
    this.listQuery = {
      page: 1,
      limit: 10,
      hsnNumber: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      sort: 'id,ASC',
      isExcel: false,
      status: undefined,
      assignedAgentId: undefined
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.loggedInAdmin = null;
  }
  async activated() {
    try {
      this.loggedInAdmin = AdminModule;
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      // get dispatch list
      await this.getList();
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      if (this.listQuery.branchId) {
        // Optionally, you can handle any additional logic here if needed
        this.handleFilter(); // Trigger any necessary actions when the branch is pre-selected
      }
      // get dispatch list
      await this.getStateList();
      await this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  getPendingAmountForPeriod(row, period) {
    const periodObject = row.pendingAmountWithPeriod.find(item => item.period === period);
    return periodObject ? periodObject.pendingAmount : 0;
  }
  async fetchBranches(superAdmin = true) {
    this.branchListLoading = true;
    // Base query
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    //  filter only if superAdmin is false
    if (!superAdmin) {
      if (this.listQuery.branchId.length === 0) {
        this.listQuery.branchId = AdminModule.branchIds;
      }
      query.id = this.listQuery.branchId;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    // Fetch branch list
    this.branchList = await getBranches(getQuery(query));
    this.branchListLoading = false;
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      const data = await dealerWiseOsOdReport(this.listQuery);
      this.list = data.data;
      this.total = data.total;
      this.grandTotal = data.grandTotal; // ← add this
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(query = null) {
    try {
      if (query && query.length > 2) {
        this.cityListLoading = true;
        this.cityList = await getCities(getQuery({
          name: query,
          filter: {
            name: '$contL'
          }
        }));
      }
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleClearBranch() {
    // Assign branchId using BranchAgentService
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    // Fetch agents for the assigned branchId
    this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    // If branchId is cleared, trigger handleClearBranch first
    // handle branch and agent code
    // Fetch agents for a single branch
    if (this.listQuery.agentId) {
      const agentData = await getAgentById(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    }
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = cleanListQuery(this.listQuery);
    try {
      this.listQuery.isExcel = true;
      const query = this.listQuery;
      const blob = await downloadOsOdExcel(query);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'dealer-os-ageing.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error(`${error}`);
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  getTooltipMessage(row) {
    if (this.checkCreditStatus(row) && row.status === 'Blocked') {
      return 'Dealer Blocked By Admin';
    } else if (this.checkCreditStatus(row)) {
      return 'Credit Limit Exceeded and Overdues above Credit Period';
    } else if (row.status === 'Blocked') {
      return 'Dealer Blocked By Admin';
    }
  }
  getLockColor(row) {
    if (this.checkCreditStatus(row) && row.status === 'Blocked') {
      return 'red'; // Both conditions are true
    } else if (this.checkCreditStatus(row)) {
      return 'orange'; // Only credit check is true
    } else if (row.status === 'Blocked') {
      return ''; // Keep default icon color
    }
  }
  checkCreditStatus(data) {
    const totalOutstanding = data.totalOutstanding;
    const creditLimit = parseFloat(data.creditLimit);
    const creditPeriod = data.creditPeriod;
    // Check if totalOutstanding exceeds creditLimit
    if (totalOutstanding > creditLimit) {
      // Check if any period exceeding the credit period has invoices
      return data.pendingAmountWithPeriod.some(period => {
        const periodDays = period.period.split(' - ')[0].replace('+', '');
        return parseInt(periodDays) > creditPeriod && period.invoiceAndDebitIds.length > 0;
      });
    }
    return false;
  }
  async downloadAgeingReportPdf(params) {
    try {
      // get invoice url
      this.listLoading = true;
      const url = await downloadInvoiceAgeingPdf(params);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate Ageing Report',
          type: 'error'
        });
      }
    } catch (error) {} finally {
      this.listLoading = false;
    }
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const fmt = val => '₹' + Math.round(val).toLocaleString('en-IN');
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Page Total / Grand Total';
        return;
      }
      const periodColumns = [{
        label: 'Outstanding(0-30 days)',
        period: '0 - 30 days'
      }, {
        label: 'Outstanding(31-60 days)',
        period: '31 - 60 days'
      }, {
        label: 'Outstanding(61-90 days)',
        period: '61 - 90 days'
      }, {
        label: 'Outstanding(91-120 days)',
        period: '91 - 120 days'
      }, {
        label: 'Outstanding(121-150 days)',
        period: '121 - 150 days'
      }, {
        label: 'Outstanding(150+ days)',
        period: '150+ days'
      }];
      // Total Outstanding
      if (column.property === 'totalOutstanding') {
        var _this$grandTotal;
        const pageTotal = data.reduce((acc, row) => acc + Number(row.totalOutstanding), 0);
        const grandTotal = Number((_this$grandTotal = this.grandTotal) === null || _this$grandTotal === void 0 ? void 0 : _this$grandTotal.totalOutstanding) || 0;
        sums[index] = `${fmt(pageTotal)} / ${fmt(grandTotal)}`;
        return;
      }
      // Credit Limit
      if (column.property === 'creditLimit') {
        var _this$grandTotal2;
        const pageTotal = data.reduce((acc, row) => acc + Number(row.creditLimit), 0);
        const grandTotal = Number((_this$grandTotal2 = this.grandTotal) === null || _this$grandTotal2 === void 0 ? void 0 : _this$grandTotal2.totalCreditLimit) || 0;
        sums[index] = `${fmt(pageTotal)} / ${fmt(grandTotal)}`;
        return;
      }
      // Credit Available
      if (column.label === 'Credit Available') {
        var _this$grandTotal3, _this$grandTotal4;
        const pageTotal = data.reduce((acc, row) => acc + (Number(row.creditLimit) - Number(row.totalOutstanding)), 0);
        const grandCreditLimit = Number((_this$grandTotal3 = this.grandTotal) === null || _this$grandTotal3 === void 0 ? void 0 : _this$grandTotal3.totalCreditLimit) || 0;
        const grandOutstanding = Number((_this$grandTotal4 = this.grandTotal) === null || _this$grandTotal4 === void 0 ? void 0 : _this$grandTotal4.totalOutstanding) || 0;
        sums[index] = `${fmt(pageTotal)} / ${fmt(grandCreditLimit - grandOutstanding)}`;
        return;
      }
      // Period buckets
      const matchedPeriod = periodColumns.find(p => p.label === column.label);
      if (matchedPeriod) {
        var _this$grandTotal5;
        const pageTotal = data.reduce((acc, row) => acc + this.getPendingAmountForPeriod(row, matchedPeriod.period), 0);
        const grandPeriod = (_this$grandTotal5 = this.grandTotal) === null || _this$grandTotal5 === void 0 || (_this$grandTotal5 = _this$grandTotal5.pendingAmountWithPeriod) === null || _this$grandTotal5 === void 0 ? void 0 : _this$grandTotal5.find(p => p.period === matchedPeriod.period);
        const grandTotal = Number(grandPeriod === null || grandPeriod === void 0 ? void 0 : grandPeriod.pendingAmount) || 0;
        sums[index] = `${fmt(pageTotal)} / ${fmt(grandTotal)}`;
        return;
      }
      sums[index] = '';
    });
    return sums;
  }
  async handleClearCache() {
    try {
      await this.$confirm('This will clear all cached data for this report. Fresh data will be fetched on the next load. Continue?', 'Clear Cache', {
        confirmButtonText: 'Yes, Clear Cache',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      // User confirmed — call your cache-clear API here
      await clearOsOdCache(this.listQuery); // replace with your actual API call
      this.$notify.success({
        title: 'Cache Cleared',
        message: 'Cache has been cleared successfully. Refreshing data...'
      });
      await this.getList();
    } catch {
      // User clicked Cancel — do nothing
    }
  }
};
default_1 = __decorate([Component({
  name: 'DealerWiseOsOdReportList',
  components: {
    Pagination,
    Inr,
    Enabled
  }
})], default_1);
export default default_1;